module.exports = __webpack_public_path__ + "img/7a562d2bab3ee8ec55ff644719de3007.png";